import React, { useState } from 'react';
import {
  ActionList,
  ActionListItem,
  Dropdown,
  DropdownOverlay,
  SelectInput
} from '@razorpay/blade/components';

export type ColumnSelectorProps = {
  options: Array<{ title: string; value: string }>;
  onChange: React.Dispatch<React.SetStateAction<string[]>>;
  values: string[];
};

export const ColumnsSelector = ({
  options,
  onChange,
  values,
}: ColumnSelectorProps) => {
  const [isOpenColumnSelector, setIsOpenColumnSelector] = useState(false);

  return (
    <Dropdown
      isOpen={isOpenColumnSelector}
      onOpenChange={(isOpen) => {
        setIsOpenColumnSelector(isOpen);
      }}
      _width="200px"
      selectionType="multiple">
      <SelectInput
        value={values}
        onChange={({ values }) => {
          onChange(values);
        }}
        placeholder="Filter"
        label=""
      />
      <DropdownOverlay width="300px">
        <ActionList>
          {options.length === 1
            ? [
                <ActionListItem
                  key={options[0].value}
                  title={options[0].title}
                  value={options[0].value}
                />,
              ]
            : options.map(({ title, value }) => (
                <ActionListItem key={value} title={title} value={value} />
              ))}
        </ActionList>
      </DropdownOverlay>
    </Dropdown>
  );
};
